<template>
  <CritereBase :selected="selected" @select="(value) => $emit('select', value)">
    <CustomSelectComponent
      label="Département du tiers"
      :labelCols="{ md: 6 }"
      :options="options"
      :value="params[0].valeur"
      @input="(value) => inputParam(0, value)"
    ></CustomSelectComponent>
  </CritereBase>
</template>

<script>
import CritereBase from "./CritereBase.vue";
import CustomSelectComponent from "../../inputs/CustomSelectComponent.vue";
import ReferentielService from "../../../services/referentiel.service";
import { props, methods } from "./shared";
export default {
  name: "CritereDepartement",
  components: { CritereBase, CustomSelectComponent },
  props: { ...props },
  data: () => ({ options: [] }),
  async created() {
    let response = await ReferentielService.getAllDepartements();
    this.options = response.data.map((d) => ({
      value: d.codeDepartement,
      text: `${d.codeDepartement} ${d.libelle}`,
    }));
  },
  methods: { ...methods },
};
</script>
